import { PlatformPressable } from '@react-navigation/elements';
import { ComponentProps, ReactNode } from 'react';

import { useHover } from '@hooks/useHover';

type Props = Omit<ComponentProps<typeof PlatformPressable>, 'children'> & {
  children: (data: {
    /** `true` when the mouse curser is within the container or the platform is not web */
    hover: boolean;
  }) => ReactNode;
};

/** Provides access to an object that exposes the hover state of the component */
export const Hoverable = ({ children, ...props }: Props) => {
  // Canonical hover behaviour (TA-9005).
  const { isHovered: hover, hoverProps } = useHover({
    onHoverIn: props.onHoverIn as () => void,
    onHoverOut: props.onHoverOut as () => void,
  });
  return (
    <PlatformPressable
      {...props}
      onHoverIn={hoverProps.onHoverIn}
      onHoverOut={hoverProps.onHoverOut}
      accessible={false}
      pressOpacity={1}>
      {children({ hover })}
    </PlatformPressable>
  );
};
